import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import FullScreenLoader from "./FullScreenLoader";
import FormErrorMessage from "../components/forms/FormErrorMessage";

import { getProjects, getScheduleOfProject } from "../actions/projectActions";

import { Grid, Button } from "@material-ui/core";
import InputElement from "./InputElement";
import { InputElementSize, InputElementType } from "../types/enums";

const ProjectsSchedule = (props) => {
  const [showAllProjects, setShowAllProjects] = useState(false);
  const [projects, setProjects] = useState([]);

  const [beginDatetime, setBeginDatetime] = useState(moment().startOf("week"));
  const [endDatetime, setEndDatetime] = useState(moment().endOf("week"));

  const [isFetching, setIsFetching] = useState(false);

  const [days, setDays] = useState([
    moment().weekday(0),
    moment().weekday(1),
    moment().weekday(2),
    moment().weekday(3),
    moment().weekday(4),
    moment().weekday(5),
    moment().weekday(6),
  ]);

  useEffect(() => {
    refreshData();
  }, []);

  const refreshData = async () => {
    setIsFetching(true);
    setProjects([]);
    updateDays();
    let projects = await props.getProjects({
      beginDate: beginDatetime,
      endDate: endDatetime,
    });
    const shifts = await Promise.all(
      projects.map((p) =>
        props.getScheduleOfProject(p.id, beginDatetime, endDatetime),
      ),
    );
    projects.forEach((project, index) => {
      project.shifts = shifts[index] || [];
    });
    setProjects(projects);
    setIsFetching(false);
  };

  const updateDays = () => {
    const _days = days.map((d, i) => moment(beginDatetime).weekday(i));
    setDays(_days);
  };

  const previousWeek = () => {
    setBeginDatetime(beginDatetime.subtract(1, "week"));
    setEndDatetime(endDatetime.subtract(1, "week"));
    refreshData();
  };

  const currentWeek = () => {
    setBeginDatetime(moment().startOf("week"));
    setEndDatetime(moment().endOf("week"));
    refreshData();
  };

  const nextWeek = () => {
    setBeginDatetime(beginDatetime.add(1, "week"));
    setEndDatetime(endDatetime.add(1, "week"));
    refreshData();
  };

  return (
    <Fragment>
      <Grid container spacing={3}>
        <InputElement
          key="showAllProjects"
          item={{
            id: "showAllProjects",
            type: InputElementType.CHECKBOX,
            label: "Alle projecten",
            size: InputElementSize.S,
            state: showAllProjects,
            setState: setShowAllProjects,
          }}
        />

        <Grid item xs={12} sm={6}></Grid>
      </Grid>

      <br />

      <div style={{ textAlign: "center" }}>
        <Button onClick={previousWeek}>Vorige week</Button>
        <Button onClick={currentWeek}>Huidige week</Button>
        <Button onClick={nextWeek}>Volgende week</Button>
      </div>

      <br />

      <div className="horizontal-scroll-container">
        <table className="schedule-table">
          <thead>
            <tr>
              <td>Medewerker</td>
              {days.map((d) => (
                <td key={d.format("ddd DD MMM")}>{d.format("ddd DD MMM")}</td>
              ))}
            </tr>
          </thead>
          <tbody>
            {projects
              .filter((project) => !showAllProjects || !project.deletedAt)
              .map((project) => {
                if (
                  showAllProjects ||
                  (project.shifts && project.shifts.length)
                ) {
                  return (
                    <tr key={project.id} height="100">
                      <td>
                        <a
                          href={`/company/${project.companyEmail}/project/${project.id}`}
                        >
                          {project.name}
                        </a>
                      </td>
                      {days.map((day, i) => {
                        let shifts =
                          project.shifts.filter((s) =>
                            day.isSame(s.beginDatetime, "day"),
                          ) || [];

                        return (
                          <td key={i}>
                            {shifts.map((s) => {
                              return (
                                <Fragment key={s.id}>
                                  {s.employees.map((e) => {
                                    return (
                                      <Fragment key={e.id}>
                                        <span>
                                          {moment(
                                            e.CompanyEmployeeShift
                                              .startDateTime || s.beginDatetime,
                                          ).format("LT")}{" "}
                                          -{" "}
                                          {moment(
                                            e.CompanyEmployeeShift
                                              .endDateTime || s.endDatetime,
                                          ).format("LT")}{" "}
                                          <br />
                                          <a
                                            href={`/company/${e.companyEmail}/employee/${e.employeeEmail}`}
                                          >
                                            {e.employee.firstName}{" "}
                                            {e.employee.lastName}
                                          </a>
                                        </span>
                                        <br />
                                        <br />
                                      </Fragment>
                                    );
                                  })}
                                </Fragment>
                              );
                            })}
                          </td>
                        );
                      })}
                    </tr>
                  );
                }
              })}
          </tbody>
        </table>
      </div>

      {isFetching && <FullScreenLoader />}

      {props.errorMessage && (
        <FormErrorMessage errorMessage={props.errorMessage} />
      )}
    </Fragment>
  );
};

ProjectsSchedule.propTypes = {
  getProjects: PropTypes.func.isRequired,
  getScheduleOfProject: PropTypes.func.isRequired,
  errorMessage: PropTypes.arrayOf(PropTypes.string),
};

const mapStateToProps = (state) => ({
  errorMessage:
    state.project.getProjects.errorMessage ||
    state.project.getScheduleOfProject.errorMessage,
});

export default connect(mapStateToProps, { getProjects, getScheduleOfProject })(
  ProjectsSchedule,
);



// WEBPACK FOOTER //
// ./src/components/ProjectsSchedule.js